export default "__VITE_ASSET__05a1ebae__"